import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import React from 'react';
import { BLUE, BORDER, INTER, NAVY, POPPINS, PROGRESS_TRACK, SLATE } from '../teacherStyles';

export function SectionCard({ children, sx = {} }: { children: React.ReactNode; sx?: Record<string, unknown> }) {
    return <Box sx={{ backgroundColor: '#fff', border: `1px solid ${BORDER}`, borderRadius: '20px', ...sx }}>{children}</Box>;
}

export function Metric({ value, label, note, icon: Icon, color, background }: { value: string; label: string; note: string; icon: React.ElementType; color: string; background: string }) {
    return (
        <SectionCard sx={{ p: 2.25 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <Box>
                    <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 24, lineHeight: 1.1, color: NAVY }}>{value}</Typography>
                    <Typography sx={{ fontFamily: INTER, fontWeight: 700, fontSize: 12.5, color: NAVY, mt: 0.65 }}>{label}</Typography>
                </Box>
                <Box sx={{ width: 40, height: 40, borderRadius: '12px', display: 'grid', placeItems: 'center', color, backgroundColor: background }}><Icon sx={{ fontSize: 21 }} /></Box>
            </Stack>
            <Typography sx={{ fontFamily: INTER, fontSize: 11.5, color: SLATE, mt: 1.35 }}>{note}</Typography>
        </SectionCard>
    );
}

export function ProgressBar({ value, color = BLUE }: { value: number; color?: string }) {
    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <LinearProgress variant="determinate" value={value} sx={{ flex: 1, minWidth: 70, height: 6, borderRadius: 3, backgroundColor: PROGRESS_TRACK, '& .MuiLinearProgress-bar': { borderRadius: 3, backgroundColor: color } }} />
            <Typography sx={{ width: 30, fontFamily: INTER, fontWeight: 700, fontSize: 11, color: NAVY }}>{value}%</Typography>
        </Stack>
    );
}
